/**
 * Surface recipes (Card, Badge, Tabs, Heading, Tag, Table). Cards are flat
 * (ENG-2145): no drop shadow — separation from the page comes from a hairline
 * border and tonal fills inside it (e.g. a Pearl header).
 */
export const Card = {
	baseStyle: {
		container: {
			borderRadius: 'xl',
			bg: 'bg.surface',
			boxShadow: 'none',
			borderWidth: '1px',
			borderColor: 'border.subtle',
		},
	},
} as const;

export const Badge = {
	baseStyle: {
		borderRadius: 'full',
		fontWeight: 'semibold',
		fontFamily: 'body',
		textTransform: 'uppercase',
		letterSpacing: '0.04em',
	},
	defaultProps: {
		colorScheme: 'brand',
	},
} as const;

export const Tag = {
	baseStyle: {
		container: {
			fontFamily: 'body',
			fontWeight: 'semibold',
			textTransform: 'uppercase',
			letterSpacing: '0.04em',
		},
	},
	defaultProps: {
		colorScheme: 'brand',
	},
} as const;

export const Heading = {
	baseStyle: {
		fontFamily: 'heading',
		color: 'fg.default',
		letterSpacing: '-0.01em',
	},
} as const;

export const Tabs = {
	defaultProps: {
		colorScheme: 'brand',
	},
} as const;

/**
 * Tables: Pearl header (`bg.subtle`) over transparent cells so the Cloud
 * modal/page shell reads as white content, and row-level selection tints
 * (set on `Tr`) still show through.
 */
export const Table = {
	baseStyle: {
		th: {
			bg: 'bg.subtle',
			color: 'fg.muted',
		},
	},
} as const;
